import { render, staticRenderFns } from "./TruckRemainingStatsMeasurementFragment.vue?vue&type=template&id=58266bc6&scoped=true&"
import script from "./TruckRemainingStatsMeasurementFragment.vue?vue&type=script&lang=js&"
export * from "./TruckRemainingStatsMeasurementFragment.vue?vue&type=script&lang=js&"
import style0 from "./TruckRemainingStatsMeasurementFragment.vue?vue&type=style&index=0&id=58266bc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58266bc6",
  null
  
)

/* custom blocks */
import block0 from "./TruckRemainingStatsMeasurementFragment.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports